import type { IntlShape } from '@atlassian/jira-intl';

import messages from './messages';

const isValidEmailAddress = (email?: string) => {
	if (!email || typeof email !== 'string') {
		return false;
	}

	return /\S+@\S+\.\S+/.test(email);
};

export const validate =
	(formatMessage: IntlShape['formatMessage']) =>
	(currentValue: string): string | undefined => {
		if (currentValue === '') {
			return undefined;
		}
		if (!isValidEmailAddress(currentValue)) {
			return formatMessage(messages.invalidEmail);
		}

		return undefined;
	};
